import api from "@helpers/api";

import { URLS } from "@constants/urls";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${URLS.EMPLOYEES}`;

export const getEmployeeServiceData = (() => {
  return async (data: any): Promise<{ data: any }> => {
    const { dataType, ...rest } = data;
    let queryParams = "";

    if (rest && Object.keys(rest).length !== 0) {
      for (const property in rest) {
        queryParams += `&${property}=${rest[property]}`;
      }
    }

    return api
      .get(
        `${apiEndPoint}/${dataType}?page=1&size=1000${
          queryParams && queryParams
        }`,
      )
      .then((response) => ({ data: response.data }));
  };
})();
